import React from 'react';

import { FieldElementPropTypes } from '../propTypes';
import RemoveEditButton from 'core/components/remove-edit-button';

const RemoveEditField = ({ field: props }) => {
  return <RemoveEditButton {...props} />;
};
RemoveEditField.propTypes = FieldElementPropTypes;

export default RemoveEditField;
